import React, { useEffect, useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { CurrencyDollar, TrendUp, Package, Users, ClockClockwise, ShieldCheck, ArrowUpRight } from "@phosphor-icons/react";

function Tile({ label, value, icon: Icon, testid, link, tone = "default" }) {
  const body = (
    <div data-testid={testid} className="border border-border bg-white p-5 hover:border-foreground transition-colors">
      <div className="flex items-center justify-between mb-4">
        <Icon size={20} weight="duotone" className={tone === "primary" ? "text-primary" : "text-muted-foreground"} />
        {link && <ArrowUpRight size={14} className="text-muted-foreground" />}
      </div>
      <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">{label}</div>
      <div className="font-heading font-black text-3xl tracking-tighter">{value}</div>
    </div>
  );
  return link ? <Link to={link}>{body}</Link> : body;
}

export default function AdminDashboard() {
  const [kpi, setKpi] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setKpi(r.data)); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!kpi) return <div className="p-10">Loading…</div>;

  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Operations</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-8">Ops dashboard.</h1>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <Tile testid="admin-kpi-revenue" label="Revenue this month" value={`$${kpi.revenue_month.toLocaleString()}`} icon={CurrencyDollar} tone="primary" />
          <Tile testid="admin-kpi-aov" label="Avg order value" value={`$${Math.round(kpi.avg_order_value).toLocaleString()}`} icon={TrendUp} />
          <Tile testid="admin-kpi-total-orders" label="Total orders" value={kpi.total_orders} icon={Package} />
          <Tile testid="admin-kpi-delivered" label="Delivered" value={kpi.delivered} icon={ShieldCheck} />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Tile testid="admin-kpi-new" label="New requests" value={kpi.new_requests} icon={ClockClockwise} link="/admin/requests?status=submitted" />
          <Tile testid="admin-kpi-clarifications" label="Clarifications" value={kpi.clarifications} icon={Users} link="/admin/requests?status=clarification_required" />
          <Tile testid="admin-kpi-quotes-await" label="Quotes awaiting decision" value={kpi.quotes_awaiting} icon={Package} link="/admin/requests?status=estimate_ready" />
          <Tile testid="admin-kpi-in-production" label="In production" value={kpi.in_production} icon={Package} link="/admin/orders" />
          <Tile testid="admin-kpi-qa" label="Quality review" value={kpi.quality_review} icon={ShieldCheck} link="/admin/orders" />
          <Tile testid="admin-kpi-ready" label="Ready for delivery" value={kpi.ready_for_delivery} icon={ShieldCheck} link="/admin/orders" />
          <Tile testid="admin-kpi-await-payment" label="Awaiting payment" value={kpi.awaiting_payment} icon={CurrencyDollar} link="/admin/requests?status=awaiting_payment" />
          <Tile testid="admin-kpi-replacements" label="Replacements" value={kpi.replacements} icon={ClockClockwise} link="/admin/orders" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
